var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_609_2172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 14,
    width: 70.5,
    height: 70.5,
    rx: 35.25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_2172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7989 41.5387C47.972 39.91 51.0132 39.1883 53.9625 39.798C59.816 41.0114 62.868 45.6951 62.9691 51.5269C63.0531 56.2667 60.0447 62.1047 55.4683 63.9916C52.7305 65.1209 49.1745 63.9667 48.0592 61.078C47.6438 60 47.7263 58.9531 47.9005 57.8985L48.0249 57.1954C48.1152 56.7085 48.2069 56.2169 48.2583 55.7191C48.3625 54.7096 47.7854 54.0811 47.0558 53.56L46.6825 53.308L45.8176 52.7636L45.4038 52.4789C44.4238 51.7774 43.3847 50.7787 42.9554 48.996C42.2009 45.8771 43.5932 43.1938 45.7989 41.5387ZM41.1945 35.6945C42.0196 35.6945 42.8109 36.0223 43.3944 36.6057C43.9778 37.1891 44.3056 37.9805 44.3056 38.8056C44.3056 39.6307 43.9778 40.422 43.3944 41.0055C42.8109 41.5889 42.0196 41.9167 41.1945 41.9167C40.3694 41.9167 39.578 41.5889 38.9946 41.0055C38.4112 40.422 38.0834 39.6307 38.0834 38.8056C38.0834 37.9805 38.4112 37.1891 38.9946 36.6057C39.578 36.0223 40.3694 35.6945 41.1945 35.6945ZM62.1945 37.25C62.607 37.25 63.0027 37.4139 63.2944 37.7056C63.5862 37.9974 63.75 38.393 63.75 38.8056C63.75 39.2181 63.5862 39.6138 63.2944 39.9055C63.0027 40.1973 62.607 40.3611 62.1945 40.3611C61.7819 40.3611 61.3863 40.1973 61.0945 39.9055C60.8028 39.6138 60.6389 39.2181 60.6389 38.8056C60.6389 38.393 60.8028 37.9974 61.0945 37.7056C61.3863 37.4139 61.7819 37.25 62.1945 37.25ZM48.1945 33.3611C48.5009 33.3611 48.8043 33.4215 49.0874 33.5388C49.3705 33.656 49.6277 33.8279 49.8444 34.0446C50.0611 34.2612 50.2329 34.5185 50.3502 34.8016C50.4675 35.0846 50.5278 35.3881 50.5278 35.6945C50.5278 36.0009 50.4675 36.3043 50.3502 36.5874C50.2329 36.8705 50.0611 37.1277 49.8444 37.3444C49.6277 37.5611 49.3705 37.7329 49.0874 37.8502C48.8043 37.9675 48.5009 38.0278 48.1945 38.0278C47.5756 38.0278 46.9822 37.782 46.5446 37.3444C46.107 36.9068 45.8612 36.3133 45.8612 35.6945C45.8612 35.0756 46.107 34.4821 46.5446 34.0446C46.9822 33.607 47.5756 33.3611 48.1945 33.3611ZM55.9723 33.3611C56.2787 33.3611 56.5821 33.4215 56.8652 33.5388C57.1483 33.656 57.4055 33.8279 57.6222 34.0446C57.8388 34.2612 58.0107 34.5185 58.128 34.8016C58.2452 35.0846 58.3056 35.3881 58.3056 35.6945C58.3056 36.0009 58.2452 36.3043 58.128 36.5874C58.0107 36.8705 57.8388 37.1277 57.6222 37.3444C57.4055 37.5611 57.1483 37.7329 56.8652 37.8502C56.5821 37.9675 56.2787 38.0278 55.9723 38.0278C55.3534 38.0278 54.7599 37.782 54.3223 37.3444C53.8848 36.9068 53.6389 36.3133 53.6389 35.6945C53.6389 35.0756 53.8848 34.4821 54.3223 34.0446C54.7599 33.607 55.3534 33.3611 55.9723 33.3611Z",
    fill: "#ED4D41"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_609_2172",
    x: 0.697977,
    y: 0.17323,
    width: 102.104,
    height: 102.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.97525
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.90101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_609_2172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_609_2172",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_2172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3333,
    height: 37.3333,
    fill: "white",
    transform: "translate(33.4167 30.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKick);
export default __webpack_public_path__ + "static/media/Kick.57ab4e29509c8d065351f6f54c510ea5.svg";
export { ForwardRef as ReactComponent };